import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

const dropdownWidth = 225;

export const wrapper = css`
  height: 100%;
  pointer-events: all;

  & > div {
    width: ${dropdownWidth}px;
    box-sizing: border-box;
    border: 1px solid ${colors.gray.light};
  }
`;

export const dropdownContainer = css`
  display: flex;
  padding: 10px;
  cursor: pointer;
  background-color: ${colors.white};
`;

export const dropdownText = css`
  color: ${colors.gray.dark};
  user-select: none;
`;

export const dropdownIcon = (isDropdownOpen: boolean) => css`
  color: ${colors.gray.default};
  margin-left: auto;

  transform: rotate(${isDropdownOpen ? '-90' : '90'}deg);
  -webkit-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
`;

export const overlayContainer = css`
  margin-top: -2px;
  padding: 0 5px 10px;
  background-color: white;
`;

export const legendRow = css`
  display: flex;
  align-items: center;

  & span {
    margin-left: 5px;
  }

  &:not(:last-child) {
    margin-bottom: 5px;
  }
`;
